module.exports = __webpack_public_path__ + "img/cgcc.289ba750.png";